import { render, staticRenderFns } from "./Desktop.vue?vue&type=template&id=6257c22c&scoped=true&"
import script from "./Desktop.vue?vue&type=script&lang=ts&"
export * from "./Desktop.vue?vue&type=script&lang=ts&"
import style0 from "./Desktop.vue?vue&type=style&index=0&id=6257c22c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6257c22c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6257c22c', component.options)
    } else {
      api.reload('6257c22c', component.options)
    }
    module.hot.accept("./Desktop.vue?vue&type=template&id=6257c22c&scoped=true&", function () {
      api.rerender('6257c22c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/learningPathV2/Desktop.vue"
export default component.exports